export { default } from './SectionStaticPageContent';
